import React,{useState} from 'react'
import { Dialog} from "@blueprintjs/core";
import { getAuth, signOut } from "firebase/auth";
import logo from '../img/logo.png'

function NavBar(props) {

    const {email,photoURL} = props.info
    const setDataNull = props.setDataNull
    const [visible,setVisible] = useState(false)

    const logout = async()=>{
      const auth = getAuth();
      signOut(auth).then(() => {
        // Sign-out successful.
      }).catch((error) => {
        // An error happened.
        console.log(error,'error is signOut')
      })
    }
    return (
        <div>
              <nav class="bp3-navbar bp3-dark">
                <div>
                    <div class="bp3-navbar-group bp3-align-left">
                       <img src={logo} alt="logo" id="logo" />
                        <h3 id="navbar-h3">Stack-Board</h3>
                  </div>

              <div class="bp3-navbar-group bp3-align-right">
                <button class="bp3-button bp3-minimal bp3-icon-tag" onClick={()=>setDataNull()}>Shared</button>
                <span class="bp3-navbar-divider"></span>
                <div onClick={()=>setVisible(prev=>!prev)}> <img src={photoURL}  style={{width:25,height:25,borderRadius:14}}/></div>

              </div>
           </div>
            </nav>

            <Dialog isOpen={visible} style={{backgroundColor:'#30404D'}}>
              <h3 style={{paddingLeft:20,color:'#ecf1f5',fontSize:24}} id="h3">
                Are you sure you want to logout ? 
              </h3>
              <div id="just-bar">
                  <button id="ok" onClick={()=>setVisible(prev=>!prev)}>No</button>
                  <button id="ok" onClick={()=>logout()}>Yes, logout</button>
              </div>
            </Dialog>
        </div>
    )
}

export default NavBar
